export default ({last_name, first_name, middle_name}: {last_name: string; first_name: string; middle_name: string} & any) => {
  if (!last_name && !first_name && !middle_name) return ' - '
  return `${last_name ? last_name : ""} ${first_name ? first_name : ""}${middle_name ? " " + middle_name : ""}`;
};